import { Client } from "stoat.js";

export async function canManageSoundboard(
  client: Client,
  serverId: string,
): Promise<boolean> {
  try {
    const [key, value] = client.authenticationHeader;

    const response = await fetch(
      `/soundboard-api/servers/${encodeURIComponent(serverId)}/settings`,
      {
        headers: {
          [key]: value,
        },
      },
    );

    if (!response.ok) {
      return false;
    }

    const data = (await response.json()) as {
      can_manage?: boolean;
    };

    return data.can_manage === true;
  } catch {
    return false;
  }
}
